import { getSubscriptionCenterWidgetConfig } from './widgets/SubscriptionCenter/widgetConfig';
import { getSubscriptionTipsWidgetConfig } from './widgets/SubscriptionTips/widgetConfig';
import { getTierContentWidgetConfig } from './widgets/TierContent/widgetConfig';
import { getTiersWidgetConfig } from './widgets/Tiers/widgetConfig';

export const getSubscriptionWidgetConfigs = ({ t, dispatch }) =>
  ({
    ownerDesktop: {
      subscriptionCenter: getSubscriptionCenterWidgetConfig({ t, dispatch }),
      subscriptionTips: getSubscriptionTipsWidgetConfig({ t, dispatch }),
    },
    ownerMobile: {
      subscriptionCenter: getSubscriptionCenterWidgetConfig({ t, dispatch }),
    },
    mainContent: {
      tiers: getTiersWidgetConfig({ t, dispatch }),
      tierContent: getTierContentWidgetConfig({ t, dispatch }),
    },
  } as any);
